/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInviteDto } from '../models/CreateInviteDto';
import type { ObjectResponseDto } from '../models/ObjectResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvitationsService {
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static invitationsControllerInvite({
        companyId,
        hid,
        requestBody,
    }: {
        companyId: string,
        hid: string,
        requestBody: CreateInviteDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{companyId}/hiring/{hid}/invite',
            path: {
                'companyId': companyId,
                'hid': hid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static invitationsControllerList({
        companyId,
        hid,
    }: {
        companyId: string,
        hid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{companyId}/hiring/{hid}/invites',
            path: {
                'companyId': companyId,
                'hid': hid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static invitationsControllerRedeem({
        token,
        code,
    }: {
        token: string,
        code: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invite',
            query: {
                'token': token,
                'code': code,
            },
        });
    }
}
